import React, { useState } from 'react';

import CloseIcon from '../../assets/svg-components/close_icon.svg';
import FlyingPlane from '../../assets/svg-components/flying_plane.svg';
import { cn } from '../../utils/classname';
import Dialog from '../dialog/dialog';
import { Label } from '../label/label';
import ShareBox from '../share-box/share-box';
import { SocialMedia } from '../social-media-buttons/social-media';
import { Title } from '../title/title';
import { Translate } from '../translate';
import './share-dialog.scss';

type ModalProps = {
  isOpen: boolean;
  setIsDialogOpen: any;
};

const ShareDialog: React.FC<ModalProps> = ({ isOpen, setIsDialogOpen }) => {
  const [isClosing, setIsClosing] = useState(false);

  const wrapperClasses = cn('bd-share-dialog__wrapper', isClosing ? 'closing' : '');

  return (
    <Dialog
      wrapperClass={wrapperClasses}
      isOpen={isOpen}
      setIsDialogOpen={setIsDialogOpen}
      isClosing={isClosing}
      setIsClosing={setIsClosing}
    >
      <div className="bd-share-dialog">
        <div className="bd-share-dialog__title">
          <Title weight="bold" level="6">
            <Translate id="translate.share.dialog.title" />
          </Title>{' '}
          <Label color="#98E5B9">
            <Title weight="bold" level="6">
              <Translate id="translate.share.dialog.hashtag" />
            </Title>
          </Label>
        </div>
        <ShareBox />
        <SocialMedia />
        <CloseIcon onClick={() => setIsClosing(true)} className="bd-share-dialog__close-icon" />
        <FlyingPlane className="bd-share-dialog__flying-plane" />
      </div>
    </Dialog>
  );
};
export default ShareDialog;
